// extracted by mini-css-extract-plugin
export var cartContainer = "_oq-4";
export var gray = "_oq-1";
export var itemContainer = "_oq-2";
export var itemDetails = "_oq-3";
export var strong = "_oq-0";